import React from "react";

function FooterMobile() {
  return (
    <div className="text-center text-white md:text-xl">
      <h6>Copyright © 2025 Orevan. All Rights Reserved.</h6>
    </div>
  );
}

export default FooterMobile;
